import React from 'react';
import './btnSend.css';

const BtnSend = () => {
  return (
    <>
      <button className="btnSend" type="submit" value="Send">
        Send
      </button>
    </>
  );
};

export default BtnSend;
